import React from 'react';

import { KalturaPlayerProvider } from '@/infrastructure/libs/kaltura-react';
import { Video } from '@/presentation/screens/classroom/classroom.vm';

import Player, { VideoProgress } from './player';

interface PlayerContainerProps {
  video: Video;
  onVideoProgress: { (videoProgress: VideoProgress): void };
  onVideoPlaying?: () => void;
  autoPlay?: boolean;
}

export const PlayerContainer: React.FC<PlayerContainerProps> = ({
  video,
  onVideoProgress,
  onVideoPlaying,
  autoPlay,
}: PlayerContainerProps) => {
  const playerBundleConfig = {
    bundlerUrl: 'https://cdnapisec.kaltura.com',
    partnerId: '1612851',
    uiConfId: '47228233',
  };

  if (!video) return null;

  const { kalturaId } = video;

  const entryConfig = {
    entryId: kalturaId,
  };

  if (!kalturaId) return null;

  return (
    <KalturaPlayerProvider playerBundleConfig={playerBundleConfig}>
      <Player
        entryConfig={entryConfig}
        onVideoProgress={onVideoProgress}
        onVideoPlaying={onVideoPlaying}
        autoPlay={autoPlay}
      />
    </KalturaPlayerProvider>
  );
};
